import { DefaultAppWrappers } from 'vendor/components/DefaultApp/DefaultApp'
import { ReactQueryClientProvider } from './components/ReactQueryClientProvider'

DefaultAppWrappers.push(ReactQueryClientProvider)
